import React from 'react';

import DescriptionSettings from '../descriptionSettings';
import IndustrySettings from '../industrySettings';
import LanguageSettings from '../languageSettings';
import MailInformationSettings from '../mainInformationSettings';
import MainSettings from '../mainSettings';
import MembershipSettings from '../membershipSettings';
import PicturesSettings from '../picturesSettings';
import RateSettings from '../rateSettings';
import ServicesSettings from '../servicesSettings';
import SocialSettings from '../socialSettings';
import SoftwareSettings from '../softwareSettings';
import SpecialOfferSettings from '../specialOfferSettings';
import TaxRepresentationSettings from '../taxRepresentationSettings';
import TeamSettings from '../teamSettings';

export const SETTINGS_TYPES = {
  MAIN_SETTINGS: {
    title: 'companyEdit.settingsTypes.settings',
    content: (props) => <MainSettings {...props} />,
  },
  MAIN_INFORMATION: {
    title: 'companyEdit.settingsTypes.main',
    content: (props) => <MailInformationSettings {...props} />,
  },
  DESCRIPTION: {
    title: 'companyEdit.settingsTypes.desc',
    content: ({ updateCompany, isAdmin, setActiveSettingType }) => (
      <DescriptionSettings {...{ isAdmin, updateCompany, setActiveSettingType }} />
    ),
  },
  SOCIAL: {
    title: 'companyEdit.settingsTypes.social',
    content: (props) => <SocialSettings {...props} />,
  },
  RATE: {
    title: 'companyEdit.settingsTypes.rate',
    content: (props) => <RateSettings {...props} />,
    withWarningText: true,
  },
  SOFTWARE: {
    title: 'companyEdit.settingsTypes.software',
    content: (props) => <SoftwareSettings {...props} />,
  },
  SERVICES: {
    title: 'companyEdit.settingsTypes.services',
    content: (props) => <ServicesSettings {...props} />,
  },
  INDUSTRIES: {
    title: 'companyEdit.settingsTypes.industry',
    content: (props) => <IndustrySettings {...props} />,
  },
  SPECIAL_OFFER: {
    title: 'companyEdit.settingsTypes.specialOffer',
    content: (props) => <SpecialOfferSettings {...props} />,
  },
  LANGUAGES: {
    title: 'companyEdit.settingsTypes.languages',
    content: (props) => <LanguageSettings {...props} />,
  },
  MEMBERSHIP: {
    title: 'companyEdit.settingsTypes.member',
    content: (props) => <MembershipSettings {...props} />,
  },
  TAX_REPRESENTATION: {
    title: 'companyEdit.settingsTypes.taxRepresentation',
    content: (props) => <TaxRepresentationSettings {...props} />,
  },
  TEAM: {
    title: 'companyEdit.settingsTypes.team',
    content: (props) => <TeamSettings {...props} />,
  },
  COMPANY_PICTURES: {
    title: 'companyEdit.settingsTypes.pictures',
    content: (props) => <PicturesSettings {...props} />,
  },
};
